import React from 'react';
import { ModalDialog } from '../formFields/Dialog';

 const styles = {
     root: {
         marginBottom: "12px",
         float: "right",
         height: "32px",
         minWidth: "190px",
         width: "250px",
         marginRight: "-5px"
     },
 };

class BulkUpdateButton extends React.Component {

    render() {
        return ( 
                <div>
                    <ModalDialog
                        btnClassName = {styles.root}
                        btnPrimary = "true"
                        title = {"Bulk Update " + this.props.myQARTasksCount + " QAR Tasks"}
                        text = {"Are you sure you want to bulk approve " + this.props.myQARTasksCount + " QAR Tasks?"}
                        buttonName = {"Bulk Update " + this.props.myQARTasksCount + " QAR Tasks"}
                        actionConfirmed = {this.props.onApprove}
                    />
                </div>
            );
    };       
}

export default BulkUpdateButton;


// WEBPACK FOOTER //
// ./src/components/ManageCenter/BulkUpdateButton.js